import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

@withRouter
export default class SearchField extends React.Component {
  
  static propTypes = {
    fullWidth: PropTypes.bool,
    label : PropTypes.string,
    type : PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    fullWidth : false,
    defaultValue: '',
    onChange: value => {}
  }

  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)

    this.state = {
      value : this.props.defaultValue || ''
    }
    if (this.state.value) {
      this.props.onChange(this.state.value)
    }
  }

  onChange(value) {
    this.setState({ value })
    var $this = this
    setTimeout(() => {
      if ($this.state.value === value) {
        this.props.onChange(value)
      }
    }, 300)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      
    }
  }

  render() {
    let classes = [styles.SearchField]
    if (this.props.fullWidth) {
      classes.push(styles.fullWidth)
    }
    const { meta } = this.props
    let errorText = null
    if (meta) {
      if (typeof meta.error === 'string') {
        classes.push(styles.error)
        errorText = meta.error
      }
    }
    if (this.state.value.length == 0) {
      classes.push(styles.WithMagnifier)
    }
    return (
      <div style={{position:'relative'}}>
        <input 
          className={classes.join(' ')}
          type='search'
          placeholder={this.props.placeholder || ''}
          value={this.state.value}
          onChange={event => this.onChange(event.target.value)}
          />
        { 
          errorText &&
            <div key={3} className={styles.ErrorText}>{errorText}</div>
        }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/SearchField/index.jsx